/* assets/color-translations.js */
(() => {
  const normalize = value =>
    String(value || '')
      .replace(/\(.+\)/, '')
      .replace(/-.+$/, '')
      .replace(/\/.+$/, '')
      .trim()
      .toUpperCase();

  window.COLOR_TRANSLATIONS = {};
  window.getTranslatedColor = window.translateColor = value =>
    window.COLOR_TRANSLATIONS[normalize(value)] || value;

  window.applyColorTranslations = (root = document) => {
    root.querySelectorAll('[data-color-code], [js-translate-color-name]').forEach(el => {
      const value = el.dataset.colorCode || el.dataset.color;
  
      if (!value) return;
  
      el.textContent = window.getTranslatedColor(value);
    });
  };

  window.COLOR_TRANSLATIONS_READY = fetch(window.COLOR_TRANSLATIONS_URL)
    .then(res => res.ok ? res.json() : {})
    .then(data => {
      window.COLOR_TRANSLATIONS = data || {};
      window.applyColorTranslations();
      return window.COLOR_TRANSLATIONS;
    })
    .catch(() => (window.COLOR_TRANSLATIONS = {}));

  ['DOMContentLoaded', 'updateSliderEvent:init', 'addToCartPopup:init', 'pdpswatchColor:init']
    .forEach(eventName => {
      document.addEventListener(eventName, () => {
        window.COLOR_TRANSLATIONS_READY.then(() => window.applyColorTranslations());
      });
    });
})();


